import { render, staticRenderFns } from "./MarkerErrorVectors.vue?vue&type=template&id=70879c1a&scoped=true"
import script from "./MarkerErrorVectors.vue?vue&type=script&lang=js"
export * from "./MarkerErrorVectors.vue?vue&type=script&lang=js"
import style0 from "./MarkerErrorVectors.vue?vue&type=style&index=0&id=70879c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70879c1a",
  null
  
)

export default component.exports